var codeblock_default = {
  "blockStyleSpacing": "wFCQ0",
  "codeBlock": "Jv73H wFCQ0",
  "renderedInTable": "_5dTq9"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
